/**
 * @generated SignedSource<<02d29beca2cb9366deb48db0e552c3e7>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb

import type { ConcreteRequest } from 'relay-runtime';
export type preloadPersonalSpaceDetailsQuery$variables = Record<PropertyKey, never>;
export type preloadPersonalSpaceDetailsQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly space: {
        readonly dataClassificationTags: ReadonlyArray<string | null | undefined>;
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type preloadPersonalSpaceDetailsQuery = {
  response: preloadPersonalSpaceDetailsQuery$data;
  variables: preloadPersonalSpaceDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "dataClassificationTags"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "preloadPersonalSpaceDetailsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "preloadPersonalSpaceDetailsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
    "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
    "metadata": {},
    "name": "preloadPersonalSpaceDetailsQuery",
    "operationKind": "query",
    "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
  }
};
})();

(node as any).hash = "a2cf47cae3a68d2f66118a725dfea818";

export default node;
